import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ImportDocs from '../xml_import/ImportDocs';
import ApiKeysPage from './ApiKeysPage';
import MetricsPage from './MetricsPage';
import ActivityPage from './ActivityPage';
import IntegrationsPage from './integrations/IntegrationsPage';
import OutboxPage from './OutboxPage';
import OverviewPage from './OverviewPage';
import RequestLogPage from './RequestLogPage';
import { DEVELOPER_BASE, DEVELOPER_PATHS } from './routes';
import VendorCallsPage from './VendorCallsPage';
import WebhooksPage from './WebhooksPage';

/** The Developer section (backend metaplan S7b; SBX plan D9), one per dashboard: production's and the
 *  sandbox's. Documentation is the existing page, only moved here (its content is G4's). */
const DeveloperSection = (props: any) => (
    <Switch>
        <Route path={DEVELOPER_PATHS.overview}><OverviewPage /></Route>
        <Route path={DEVELOPER_PATHS.integrations}><IntegrationsPage /></Route>
        <Route path={`${DEVELOPER_PATHS.requests}/:requestId?`}><RequestLogPage /></Route>
        <Route path={`${DEVELOPER_PATHS.outbox}/:sendId?`}><OutboxPage /></Route>
        <Route path={`${DEVELOPER_PATHS.webhooks}/:deliveryId?`}><WebhooksPage /></Route>
        <Route path={DEVELOPER_PATHS.vendorCalls}><VendorCallsPage /></Route>
        <Route path={DEVELOPER_PATHS.metrics}><MetricsPage /></Route>
        <Route path={DEVELOPER_PATHS.activity}><ActivityPage /></Route>
        <Route path={DEVELOPER_PATHS.apiKeys}><ApiKeysPage {...props} /></Route>
        <Route path={DEVELOPER_PATHS.documentation}><ImportDocs {...props} /></Route>
        <Route path={DEVELOPER_BASE}><Redirect to={DEVELOPER_PATHS.overview} /></Route>
    </Switch>
);

export default DeveloperSection;
